module.exports = __webpack_public_path__ + "static/media/text-image.7a99183f.png";